import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  success: false,
  error: null,
  bonuses: [],
  allBonuses: [],
  UserAssignedBonuses: [],
  bonusType: "",
  activateLoading: false
};

const bonusSlice = createSlice({
  name: "bonus",
  initialState,
  reducers: {
    getAllBonusesStart: (state, action) => {
      state.loading = true;
      state.bonusType = action.payload;
    },
    getAllBonusesSuccess: (state, action) => {
      state.loading = false;
      state.allBonuses = action.payload;
      state.UserAssignedBonuses = action.payload.reduce((acc, bonus) => {
        acc[bonus.id] = bonus.UserAssignedBonuses || [];
        return acc;
      }, {});
    },

    getBonusMOdify: (state, action) => {
      state.allBonuses = state.allBonuses.filter(
        (bonus) => bonus?.id !== action?.payload
      );
    },
    getAllBonusesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload || "Failed to load";
    },
    getBonusStart: (state) => {
      state.loading = true;
    },
    getBonusSuccess: (state, action) => {
      state.loading = false;
      state.bonuses = action.payload;
    },
    getBonusFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
    getAuthUserBonusesStart: (state, action) => {
      if (action.payload?.activateBonus) {
        return;
      }
      state.loading = true;
    },
    getAuthUserBonusesSuccess: (state, action) => {
      state.loading = false;
      state.bonuses = action.payload;
    },
    getAuthUserBonusesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload || "Failed to load user bonuses";
    },
    activateBonusStart: (state) => {
      state.activateLoading = true;
    },
    activateBonusSuccess: (state, action) => {
      state.activateLoading = false;
    },
    activateBonusFailure: (state, action) => {
      state.activateLoading = false;
      state.error = action.payload || "Failed to activate bonus";
    },
    setUserAssignedBonuses: (state, action) => {
      state.UserAssignedBonuses = action.payload;
    },
    resetBonusState: () => initialState
  }
});

export const {
  getAllBonusesStart,
  getBonusSuccess,
  getAllBonusesSuccess,
  getBonusStart,
  getAllBonuseart,
  getBonusSusSuccess,
  getAllBonusesFailure,
  getBonusStccess,
  getBonusFailure,
  getAuthUserBonusesStart,
  getBonusMOdify,
  getAuthUserBonusesSuccess,
  getAuthUserBonusesFailure,
  activateBonusStart,
  activateBonusSuccess,
  activateBonusFailure,
  setUserAssignedBonuses,
  resetBonusState
} = bonusSlice.actions;

export default bonusSlice.reducer;
